import React, {
    useContext,
    useMemo,
    useState
} from "react";
import i18next from "i18next";
import {
    Link,
    Redirect
} from "react-router-dom";
import {
    Alert,
    Spinner
} from "react-bootstrap";
import {
    Trans
} from "react-i18next";

import AuthenticationContext from "../../context/internal/AuthenticationManager";
import Loading from "../../components/Loading";

function ForgotPasswordPageContent() {
    const authentication = useContext(AuthenticationContext);
    const [email, setEmail] = useState("");
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);

    const onError = useMemo(() => {
        return (errorMessage) => {
            setError(errorMessage);
        }
    }, []);
    const onSuccess = useMemo(() => {
        return () => {
            setSuccess(true);
        }
    }, []);
    const onSubmit = useMemo(() => {
        return (event) => {
            event.preventDefault();
            setError(null);
            authentication.forgotPassword(email, onError, onSuccess);
        }
    }, [authentication, email, onError, onSuccess]);

    const authenticationStatus = useMemo(() => {
        return authentication.getAuthenticationStatus();
    }, [authentication]);

    if(authenticationStatus === "unsupported") {
        return (
            <Alert variant="danger">
                <Trans i18nKey="errorAuthenticationUnsupported"/>
            </Alert>
        )
    }
    if(authenticationStatus === "unknown") {
        return (
            <Loading/>
        );
    }
    if(authenticationStatus === "loggedin") {
        return (
            <Redirect to="/account"/>
        )
    }
    return (
        <div
            className="py-4"
            style={{ maxWidth: "350px", marginLeft: "auto", marginRight: "auto" }}
        >
            { error ? (
                <Alert variant="danger">{ error }</Alert>
            ) : success && (
                <Alert variant="success">
                    <Trans i18nKey="forgotPasswordSuccess"/>
                </Alert>
            )}

            <form onSubmit={ onSubmit }>
                <div className="form-group">
                    <input
                        type="email"
                        className="form-control"
                        id="email"
                        placeholder={ i18next.t("email") }
                        disabled={ authentication.loading }
                        value={ email }
                        onChange={(event) => setEmail(event.target.value) }
                    />
                </div>
                <div className="d-flex justify-content-center">
                    <button
                        type="submit"
                        className="btn btn-primary px-5"
                        disabled={ authentication.loading }
                    >
                        { authentication.loading ? (
                            <Spinner animation="border" variant="dark" size="sm"/>
                        ) : (
                            <Trans i18nKey="submit"/>
                        )}
                    </button>
                </div>
            </form>
            <div className="mt-4 d-flex justify-content-center">
                <div>
                    <Link to="/login">
                        <Trans i18nKey="returnToLogin"/>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default React.memo(ForgotPasswordPageContent);
